import { sspProjectConfig } from "@/setup/openApiConfig";
import {
  InterpretationSurfaceWaterSedimentsInterpretationsApi,
  InterpretationUndergroundWaterInterpretationsApi,
  InterpretationInvestigationSynthesesApi,
  InterpretationSoilGasInterpretationsApi,
  InterpretationSoilInterpretationsApi,
  InterpretationAmbientAirInterpretationsApi,
  InterpretationExcavatedSoilInterpretationsApi,
  InterpretationFoodProductsInterpretationsApi,
} from "@socotec.io/ssp-back-sdk";

export const surfaceWaterSedimentsInterpretationApi =
  new InterpretationSurfaceWaterSedimentsInterpretationsApi(sspProjectConfig);
export const undergroundWaterInterpretationApi =
  new InterpretationUndergroundWaterInterpretationsApi(sspProjectConfig);
export const investigationSynthesesApi = new InterpretationInvestigationSynthesesApi(
  sspProjectConfig,
);
export const soilGasInterpretationsApi = new InterpretationSoilGasInterpretationsApi(
  sspProjectConfig,
);
export const soilInterpretationsApi = new InterpretationSoilInterpretationsApi(sspProjectConfig);
export const ambientAirInterpretationApi = new InterpretationAmbientAirInterpretationsApi(
  sspProjectConfig,
);
export const excavatedSoilInterpretationApi = new InterpretationExcavatedSoilInterpretationsApi(
  sspProjectConfig,
);
export const foodProductsInterpretationApi = new InterpretationFoodProductsInterpretationsApi(
  sspProjectConfig,
);
